import { Component, OnInit } from '@angular/core';
import { Experience, WMAIApiService, SchedaIntense, Attachment, Item, Stop, Word, Ost, Immagine } from '../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, AppInformationService } from '../../core/services';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ImageModal, ConfirmModal, SimpleModal } from 'src/app/core/templates';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';

@Component({
  selector: 'app-ost-view',
  templateUrl: './ost-view.component.html',
})
export class OstViewComponent implements OnInit {
  isMapVisible: boolean = false;
  isUserLoggedIn = false;
  ost: Ost;
  id: number;
  ostid: number;
  loading: boolean = true;
  imageUrl: string = "";
  firstStep: boolean = false;
  secondStep: boolean = false;
  thirdStep: boolean = false;

  isSmallScreen: boolean = false;
  isMobile: boolean = false;
  immagine: Immagine;
  immagini: Attachment[];
  currentIndex: number = 0;
  maxIndex: number = 0;

  tipologie: Attachment[];

  allegati: Attachment[] = [];
  allegato: Attachment;

  itemCurrentIndex: number = 0;
  itemMaxIndex: number = 0;


  segnalazioneForm: FormGroup;
  segnalazioneValue: string;
  segnalazioneText: string;
  showSegnalazione = true;
  wordsSegnalazione: Word[] = [];
  paramsSubscription: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private wmaiservice: WMAIApiService,
    private auth: AuthService,
    private wgisservice: WgisService,
    private breakpointObserver: BreakpointObserver,
    private activatedroute: ActivatedRoute,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private modalService: SuiModalService,
    private appService: AppInformationService
  ) {
    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });
    this.isSmallScreen = breakpointObserver.isMatched('(max-width: 768px)');
    this.isMobile = this.appService.iAmMobile();
    const segnalazioneValueCtrl = new FormControl(this.segnalazioneValue, [Validators.required]);
    const segnalazioneTextCtrl = new FormControl(this.segnalazioneText, [Validators.required]);

    this.segnalazioneForm = this.formBuilder.group({
      segnalazioneValue: new FormControl(segnalazioneValueCtrl),
      segnalazioneText: new FormControl(segnalazioneTextCtrl)
    });

    this.segnalazioneForm.controls['segnalazioneText'].patchValue('');
  }

  ngOnInit() {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    this.isMapVisible = this.wgisservice.getMapVisible();
    window.scrollTo(0, 0);

    this.id = this.activatedRoute.snapshot.params.id;
    this.paramsSubscription = this.activatedRoute.params.subscribe((param: any) => {
      this.resetVariables();
      this.id = param['id'];
      if (this.id != null) {
        this.wmaiservice.ostSingleById(this.id, this.translateService.getDefaultLang()).subscribe(data => {
          if (data[0] != null) {
            this.ost = data[0];
            this.wmaiservice.ostAmbitoById(this.id, this.translateService.getDefaultLang()).subscribe(ambito => {
              if (ambito != null && ambito.length > 0)
                this.ost.ambito = ambito;
            });
            this.wmaiservice.ostContattiById(this.id, this.translateService.getDefaultLang()).subscribe(contatti => {
              if (contatti != null && contatti.length > 0)
                this.ost.contatti = contatti;
            });
            this.wmaiservice.ostEsposizioneById(this.id, this.translateService.getDefaultLang()).subscribe(esposizione => {
              if (esposizione != null && esposizione.length > 0)
                this.ost.esposizione = esposizione;
            });
            this.wmaiservice.ostFruizioneById(this.id, this.translateService.getDefaultLang()).subscribe(fruizione => {
              if (fruizione != null && fruizione.length > 0)
                this.ost.fruizione = fruizione;
            });
            this.wmaiservice.ostProtezioneById(this.id, this.translateService.getDefaultLang()).subscribe(protezione => {
              if (protezione != null && protezione.length > 0)
                this.ost.protezione = protezione;
            });
            this.wmaiservice.ostRiconoscimentiById(this.id, this.translateService.getDefaultLang()).subscribe(riconoscimenti => {
              if (riconoscimenti != null && riconoscimenti.length > 0)
                this.ost.riconoscimenti = riconoscimenti;
            });
            this.wmaiservice.ostSegnaleticaById(this.id, this.translateService.getDefaultLang()).subscribe(segnaletica => {
              if (segnaletica != null && segnaletica.length > 0)
                this.ost.segnaletica = segnaletica;
            });
            this.wmaiservice.ostStatoFondoById(this.id, this.translateService.getDefaultLang()).subscribe(stato_fondo => {
              if (stato_fondo != null && stato_fondo.length > 0)
                this.ost.stato_fondo = stato_fondo;
            });
            this.wmaiservice.ostTipoFondoById(this.id, this.translateService.getDefaultLang()).subscribe(tipo_fondo => {
              if (tipo_fondo != null && tipo_fondo.length > 0)
                this.ost.tipo_fondo = tipo_fondo;
            });
            this.wmaiservice.ostTipologiaById(this.id, this.translateService.getDefaultLang()).subscribe(tipologia => {
              if (tipologia != null && tipologia.length > 0)
                this.ost.tipologia = tipologia;
            });
            this.wmaiservice.ostImmaginiById(this.id, this.translateService.getDefaultLang()).subscribe(immagini => {
              if (immagini != null && immagini.length > 0) {
                this.ost.immagine = immagini;
                this.immagine = this.ost.immagine[0];
                this.maxIndex = this.ost.immagine.length - 1;
              }
            });
            this.wmaiservice.ostAllegatiById(this.id, this.translateService.getDefaultLang()).subscribe(allegati => {
              if (allegati != null && allegati.length > 0)
                this.ost.allegati = allegati;
            });
            /*
            if(data[0].immagine != null && data[0].immagine.length != 0){
              this.immagini = data[0].immagine.split(';');
              this.immagini.pop();
              this.immagine = this.immagini[0];
              this.maxIndex = this.immagini.length - 1;
            }
            
            if(data[0].allegati != null && data[0].allegati.length != 0){
              this.allegati = data[0].allegati.split(';');
              this.allegati.pop();
            }

            if(data[0].tipologia != null && data[0].tipologia.length != 0){
              this.tipologie = data[0].tipologia.split(';');
              this.tipologie.pop();
            }
            */
            this.loading = false;
            this.wgisservice.showOstByObj(this.ost);
          }
        });

        this.getWordsSegnalazioneIntense();
        this.firstStep = true;
      }
    });
  }

  ngOnDestroy() {
    this.wgisservice.clearSelection();
    this.paramsSubscription.unsubscribe();
  }

  resetVariables() {
    this.imageUrl = "";
    this.immagine = null;
    this.immagini = [];
    this.currentIndex = 0;
    this.maxIndex = 0;

    this.tipologie = [];

    this.allegati = [];
    this.allegato = null;

    this.itemCurrentIndex = 0;
    this.itemMaxIndex = 0;
  }

  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }

  getWordsSegnalazioneIntense() {
    this.wmaiservice.getWordsByLocale(this.translateService.getDefaultLang(), 'segnalazioneIntense').subscribe(data => {
      this.wordsSegnalazione = data;
    });
  }

  nextImage() {
    if (this.currentIndex >= this.maxIndex) this.currentIndex = 0;
    else this.currentIndex++;
    this.immagine = this.ost.immagine[this.currentIndex];
  }

  previousImage() {
    if (this.currentIndex <= 0) this.currentIndex = this.maxIndex;
    else this.currentIndex--;
    this.immagine = this.ost.immagine[this.currentIndex];
  }

  toggleSegnalazione() {
    this.showSegnalazione = !this.showSegnalazione;
  }
  /**
   * si inoltrano delle segnalazioni attraverso un modal
   */
  submitSegnalazione() {
    if (this.id == null) return;
    var params = this.segnalazioneForm.value;
    // console.log(params);
    let title: string = this.translateService.instant('Attenzione');
    let content: string = this.translateService.instant('Vuoi innoltrare la segnalazione?');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        if (this.isUserLoggedIn) {
          this.wmaiservice.sendAlertToRas(this.id, 'ost', params).subscribe(data => {
            let title: string = this.translateService.instant('Attenzione');
            let content: string = this.translateService.instant('Segnalazione innoltrata con successo!');
            this.modalService
              .open(new SimpleModal(title, content, ModalSize.Tiny))
              .onApprove(() => {
              })
              .onDeny(() => "");
          });
        };
        this.router.navigate(['ost/' + this.id]);
        this.showSegnalazione = true;
      })
      .onDeny(() => "");
    }
    
  checkIcon(allegato){
    if(allegato.title.match(/\.(pdf|txt|doc|docx|exel|PDF|TXT|DOC|DOCX|EXEL)$/)){
      return {"file alternate outline icon": true};
    } else if (allegato.title.match(/\.(mp3|MP3|wav|WAV|wma|WMA)$/)){
      return {"file audio outline icon" : true};
    } else if(allegato.title.match(/\.(3gp|avi|mp4|mpeg|mpg|3GP|AVI|MP4|MPEG|MPG)$/)){
      return {"file video outline icon": true};
    } else if(allegato.title.match(/\.(jpg|jpeg|png|gif|bmp|JPG|JPEG|PNG|GIF|BMP)$/)){
      return {"file image outline icon": true};
    } else {
      return {"download icon": true};
    }
  }
}
